import { environment } from '../environments/environment';

type EnvConfig = typeof environment;

export function validateEnv(env: EnvConfig = environment) {
  const required: Array<keyof EnvConfig> = [
    'coreApiUrl',
    'analyticsApiUrl',
    'awsRegion',
    'identityPoolId',
    'userPoolId',
    'userPoolWebClientId',
    'fanboardUrl',
    'baseUrl',
    'env',
  ];

  const missing = required.filter((k) => !env[k]);
  if (missing.length) {
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }

  if (!env.ablyKey) {
    // Realtime is optional; warn only
    console.warn('REACT_APP_ABLY_KEY is not set. Realtime updates will be disabled.');
  }

  return true;
}

